/**
 *
 * NewAccount
 *
 */
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNewAccountSlice } from './slice';
import { selectNewAccount } from './slice/selectors';
import { routes } from 'utils/routes';
import { Link } from 'react-router-dom';
import './styles.scss';
import './modern-registration.scss';
import { toast } from 'react-toast';
import { useQuery } from 'utils/commons';

interface Props {}

const planItems = [
  {
    item: 'Unlimited signatures',
  },
  {
    item: '3 Documents per month',
  },
  {
    item: '2 team members',
  },
  {
    item: 'Unlimited templates',
  },
];

export const NewAccount = memo((props: Props) => {
  const [emailId, setEmailId] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [appsumoCode, setAppsumoCode] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [isAppsumo, setIsAppsumo] = useState(false);
  const [isAppsumoEmail, setIsAppsumoEmail] = useState(false);
  const [isTOSchecked, setTOSchecked] = useState(false);

  const [ShowEmailError, setShowEmailError] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showFirstNameError, setShowFirstNameError] = useState(false);
  const [showLastNameError, setShowLastNameError] = useState(false);
  const [showPasswordMissMatchError, setShowPasswordMissMatchError] = useState(
    false,
  );
  const [isPasswordValid, setIsPasswordValid] = useState(false);

  const params = useQuery();

  const toggleTOSChecked = () => {
    setTOSchecked(value => !value);
  };

  const [isPPchecked, setPPchecked] = useState(false);
  const togglePPChecked = () => {
    setPPchecked(value => !value);
  };
  const [userExists, setUserExists] = useState(false);
  const { actions } = useNewAccountSlice();
  const registerAccountState = useSelector(selectNewAccount);
  const dispatch = useDispatch();

  useEffect(() => {
    const isAppSumo = params.get('appSumo');
    const queryEmail = params.get('email');
    
    if (isAppSumo) {
      setIsAppsumoEmail(true);
      setIsAppsumo(true);
    } else {
      setIsAppsumoEmail(false);
    }

    if (queryEmail) {
      setEmailId(queryEmail || '');
    }
  }, []);

  const onRegister = () => {
    if (password !== confirmPassword) {
      toast.error('Passwords does not match');
    } else {
      dispatch(
        actions.onRegister({
          req: {
            firstName: firstName,
            lastName: lastName,
            email: emailId,
            password: password,
            profileCompletion: false,
          },
          successCb: () => {
            if (isAppsumoEmail) {
              toast.success(
                'Account created successfully, thank you for purchasing ContractHub via AppSumo.',
              );
            }
          },
          // errorCB: () => {}
        }),
      );
    }
  };

const clearEmailExistError = () => {
  if (registerAccountState.emailAlreadyRegistered) {
    registerAccountState.emailAlreadyRegistered = false; 
  }
  // console.log(registerAccountState.emailAlreadyRegistered)
}


  return (
    <div className="reg-modern-wrapper">
      <div className="reg-background-patterns"></div>
      <div className="reg-container">
        <div className="reg-card">
          <div className="reg-header">
            <div className="reg-logo-container">
              <div className="logoIMG">
                <img width="90" 
                src="https://contracthub-static-assets.s3.ap-south-1.amazonaws.com/animated-logo-huge.gif" 
                alt="">
                </img>

                </div>
              {/* <div className="reg-logo-glow"></div>
              <img
                width={80}
                src="https://contracthub-static-assets.s3.ap-south-1.amazonaws.com/animated-logo-huge.gif"
                alt="ContractHub"
                className="reg-logo"
              /> */}
            </div>
            <h1 className="reg-title">
              {isAppsumo ? (
                <>
                  <span className="reg-wave">👋</span> Welcome Sumo-ling!
                </>
              ) : (
               registerAccountState.stepNo === 0 || emailId === '' ? 
               <>
                  Create your account 
                </>
               : ''
              )}
            </h1>
            {/* <p className="reg-subtitle">
              <span className="reg-subtitle-icon">🚀</span>
              Start managing your documents like a pro in under 2 minutes
            </p> */}
          </div>

          {registerAccountState.stepNo === 0 || emailId === '' ? (
            <div className="reg-form-container">

              <form
                className="reg-form"
                onSubmit={e => {
                  e.preventDefault();
                  onRegister();
                }}
              >
                <div className="reg-input-row">
                  <div className="reg-input-group reg-input-animated">
                    <div className="reg-input-icon">
                      <i className="fi fi-rr-user"></i>
                    </div>
                    <label className="reg-label">First Name *</label>
                    <input
                      required
                      value={firstName}
                      name="firstName"
                      type="text"
                      className={`reg-input reg-input-with-icon ${showFirstNameError ? 'reg-input-error' : ''}`}
                      onChange={e => {
                        setFirstName(e.target.value);
                        if (e.target.value.length === 0) {
                          setShowFirstNameError(true);
                        } else {
                          setShowFirstNameError(false);
                        }
                      }}
                      placeholder="John"
                    />
                  </div>
                  <div className="reg-input-group reg-input-animated">
                    <div className="reg-input-icon">
                      <i className="fi fi-rr-user"></i>
                    </div>
                    <label className="reg-label">Last Name *</label>
                    <input
                      required
                      value={lastName}
                      name="lastName"
                      type="text"
                      className={`reg-input reg-input-with-icon ${showLastNameError ? 'reg-input-error' : ''}`}
                      onChange={e => {
                        setLastName(e.target.value);
                        if (e.target.value.length === 0) {
                          setShowLastNameError(true);
                        } else {
                          setShowLastNameError(false);
                        }
                      }}
                      placeholder="Doe"
                    />
                  </div>
                </div>

                <div className="reg-input-group reg-input-animated">
                  <div className="reg-input-icon">
                    <i className="fi fi-rr-envelope"></i>
                  </div>
                  <label className="reg-label">Email Address *</label>
                  <input
                    required
                    value={emailId}
                    name="email"
                    type="email"
                    className={`reg-input reg-input-with-icon ${
                      ShowEmailError || registerAccountState.emailAlreadyRegistered ? 'reg-input-error' : ''
                    }`}
                    onChange={e => {
                      setEmailId(e.target.value);
                      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (!emailPattern.test(e.target.value)) {
                        setShowEmailError(true);
                      } else {
                        setShowEmailError(false);
                      }
                      dispatch(actions.onClearEmailAlreadyExists())
                    }}
                    placeholder="your@email.com"
                    disabled={isAppsumoEmail}
                  />
                  {registerAccountState.emailAlreadyRegistered && (
                    <span className="reg-error-text">
                      <i className="fi fi-rr-exclamation"></i> Email already registered
                    </span>
                  )}
                </div>
                <div className="reg-input-group reg-input-animated">
                  <div className="reg-input-icon">
                    <i className="fi fi-rr-lock"></i>
                  </div>
                  <label className="reg-label">Password *</label>
                  <input
                    required
                    value={password}
                    name="password"
                    type="password"
                    className={`reg-input reg-input-with-icon ${showPasswordError ? 'reg-input-error' : ''}`}
                    onChange={e => {
                      setPassword(e.target.value);
                      const passwordPattern = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$/;
                      const isValid = passwordPattern.test(e.target.value);
                      
                      if (e.target.value.length > 0 && !isValid) {
                        setShowPasswordError(true);
                        setIsPasswordValid(false);
                      } else {
                        setShowPasswordError(false);
                        setIsPasswordValid(isValid && e.target.value.length > 0);
                      }
                      
                      // Clear confirm password if password changes
                      if (confirmPassword && e.target.value !== confirmPassword) {
                        setConfirmPassword('');
                        setShowPasswordMissMatchError(false);
                      }
                    }}
                    placeholder="••••••••"
                  />
                  <div className="reg-password-strength">
                    <span className="reg-password-hint">
                      <i className="fi fi-rr-shield-check"></i>
                      8-20 characters, 1 number, 1 letter, 1 symbol
                    </span>
                  </div>
                </div>

                {isPasswordValid && (
                  <div className="reg-input-group reg-confirm-password-slide">
                    <div className="reg-input-icon">
                      <i className="fi fi-rr-shield-check"></i>
                    </div>
                    <label className="reg-label">Confirm Password *</label>
                    <input
                      required
                      value={confirmPassword}
                      name="passwordConfirm"
                      type="password"
                      className={`reg-input reg-input-with-icon ${showPasswordMissMatchError ? 'reg-input-error' : ''}`}
                      onChange={e => {
                        setConfirmPassword(e.target.value)
                        if (e.target.value !== password) {
                          setShowPasswordMissMatchError(true);
                        } else {
                          setShowPasswordMissMatchError(false);
                        }
                      }}
                      placeholder="••••••••"
                    />
                    {showPasswordMissMatchError && (
                      <span className="reg-error-text">
                        <i className="fi fi-rr-cross-circle"></i> Passwords do not match
                      </span>
                    )}
                  </div>
                )}
                <div className="reg-checkbox-group">
                  <input
                    type="checkbox"
                    className="reg-checkbox"
                    checked={isTOSchecked}
                    onChange={toggleTOSChecked}
                    id="terms-checkbox"
                  />
                  <label htmlFor="terms-checkbox" className="reg-checkbox-label">
                    <span style={{ color: 'red' }}>* </span>
                    I agree to the{' '}
                    <a
                      href="https://www.contracthub.com/terms-of-use/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Terms and Conditions
                    </a>{' '}
                    and{' '}
                    <a
                      href="https://www.contracthub.com/privacy-policy/"
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      Privacy Policy
                    </a>
                  </label>
                </div>

                <button
                  className={`reg-submit-btn reg-submit-animated ${
                    registerAccountState.registering ? 'loading' : ''
                  }`}
                  disabled={
                    registerAccountState.registering ||
                    !isTOSchecked ||
                    !emailId ||
                    !firstName ||
                    !lastName ||
                    !isPasswordValid ||
                    !confirmPassword
                  }
                  type="submit"
                >
                  {registerAccountState.registering ? (
                    <>
                      <i className="gg-spinner reg-spinner"></i>
                      Creating Your Account...
                    </>
                  ) : (
                    <>
                      <span className="reg-btn-icon">🚀</span>
                      Create My Account
                      <span className="reg-btn-arrow">→</span>
                    </>
                  )}
                </button>
              </form>
            </div>
          ) : (
            <div className="reg-success-container">
              <h2 className="reg-success-title">🎉 Almost There!</h2>
              <div className="reg-success-text">
                <p>We've sent a verification link to:</p>
                <code className="reg-email-code">{emailId}</code>
                <p>
                  Click the link in your email to activate your account and start using ContractHub!
                </p>
                <div className="reg-success-tips">
                  <p><strong>💡 Pro tip:</strong> Check your spam folder if you don't see the email in a few minutes.</p>
                </div>
              </div>
            </div>
          )}
          
          <div className="reg-footer">
            <Link to={routes.login} className="reg-login-link">
              Already have an account? Sign in
            </Link>
            <div className="reg-copyright">
              ©2024 <a href="https://www.contracthub.com" target="_blank" rel="noopener noreferrer">ContractHub, Inc.</a> All rights reserved.
            </div>
          </div>
        </div>
      </div>
      {/* <div className="plan-details d-flex flex-column justify-content-center align-items-center">
        <div className="plan-includes">Your plan includes</div>
        <div className="plan-items-list">
          {planItems.map((item, index) => (
            <div key={index} className="plan-item">
              <i className="gg-check-r check-icon"></i>
              <div className="item">{item.item}</div>
            </div>
          ))}
        </div>
        <div className="plus-more">Plus much more...</div>
      </div> */}
    </div>
  );
});
